/**
 * All the routes
 */
export const routes = {
	login: "auth/login",
	signup: "auth/signup",
    firebaseLogin: "auth/firebase-login",
	logout: "auth/logout",
	cartItems: "/cart/items",
	cartSync: "/cart/sync",
	products: "/products",
	productImages: (productId) => `/products/${productId}/images`,
	productBasicInfo: (productId) => `/products/${productId}/basic-info`,
	productAttributes: (productId) => `/products/${productId}/attributes`,
	productExtras: (productId) => `/products/${productId}/extras`,
	productAvailability: (productId) => `/products/${productId}/availability`,
	productStock: (productId) => `/products/${productId}/stock`,
	deliveryAddress: "/delivery-addresses",
	orders: "/orders",
	companyOrders: (companyId) => `/companies/${companyId}/orders`,
	businessAnalytics: (companyId) => `/companies/${companyId}/analytics`,
	companyDeals: (companyId) => `/companies/${companyId}/deals`,
	companyDeal: (companyId, dealId) => `/companies/${companyId}/deals/${dealId}`,
	companyDealProducts: (companyId, dealId) => `/companies/${companyId}/deals/${dealId}/products`,
	companyDealPerformance: (companyId, dealId) => `/companies/${companyId}/deals/${dealId}/performance`,
	companyProductsSearch: (companyId) => `/companies/${companyId}/products/search`,
	companyProductDealRemoval: (companyId, productId, dealId) => `/companies/${companyId}/products/${productId}/deals/${dealId}`,
	viewOrder: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}`,
	markOrderAsReady: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}/ready`,
	markOrderAsProcessing: (companyId, orderId) => `/companies/${companyId}/orders/${orderId}/process`,
	payments: "/payments",
	users: "/users",
	userStats: "/users/stats",
	paymentRequests: "/payment-requests",
	reviews: "/reviews",
	capaPurchases: "/capa-purchases",
	aiCreditPurchases: "/ai-credit-purchases",
	voiceOrderSessions: "/ai/voice-business/sessions",
	orderPaymentSurpluses: "/order-payment-surpluses",
	settings: "/user-settings",
	awards: "/awards",
	transfers: "/transfers",
	follows: "/follows",
	businesses: "/businesses",
	comments: "/comments",
	mentions: "/mentions",
	deliverers: "/deliverers",
	errands: "/errands",
	featureAnnouncements: "/feature-announcements",
};